export function safeGet(key, fallback = null) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return fallback;
    const value = window.localStorage.getItem(key);
    return value === null ? fallback : value;
  } catch (e) {
    return fallback;
  }
}

export function safeSet(key, value) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return false;
    window.localStorage.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
}

export function safeRemove(key) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return false;
    window.localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

export function safeJsonParse(value, fallback = []) {
  try {
    return JSON.parse(value);
  } catch (e) {
    return fallback;
  }
}

export function getSafeSession(prefix = 'sess') {
  const key = 'ky13_session';
  let current = safeGet(key, '');
  if (!current) {
    current = `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    safeSet(key, current);
  }
  return current;
}

export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export function supportsNotification() {
  return typeof window !== 'undefined' && 'Notification' in window;
}

export function supportsMediaRecorder() {
  return typeof window !== 'undefined' && 'MediaRecorder' in window && navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
}
